const { getDate } = require('./getDate')
const { getTime } = require('./getTime')

/**
 * Visszaadja a teljes dátumot a paramétereknek megfelelően.
 * @param {string | number | Date} param - Az idő számként vagy stringként, ebből generáljuk a kimenetet.
 * @example
 * 2025-10-28T15:30:00 -> 2025-10-28 15:30:00
 * new Date("2024-01-01T00:00:00") -> 2024-01-01 00:00:00
 * @returns {string} A teljes dátum, stringként.
 */
module.exports.getFullDate = function getFullDate (param) {
  const date = getDate(param)
  const time = getTime(param)

  return `${ date } ${ time }`
}
